import { log } from '../../logger';
import { AlphaAuditClient } from '../alphaAuditClient';
import {
  AuditContext,
  AuditDecision,
  AuditExecutionResult,
} from '../types';

type CompanyDataDirectResponseData = {
  symbol?: string;
  dataType?: string;
  prospectusUrl?: string;
};

function openUrlInBrowser(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function companyDataProspectusHandler(
  client: AlphaAuditClient,
  decision: Extract<AuditDecision, { auditable: true }>,
  ctx: AuditContext
): Promise<AuditExecutionResult> {
  const response = await client.startDirectAudit<CompanyDataDirectResponseData>(
    decision.auditFunctionName,
    decision.payload
  );

  const symbol = response?.data?.symbol;
  const dataType = response?.data?.dataType;
  const prospectusUrl = response?.data?.prospectusUrl;

  if (!prospectusUrl) {
    throw new Error('company_data direct audit response missing prospectusUrl');
  }

  log.info('company_data prospectus URL retrieved', {
    functionName: decision.auditFunctionName,
    symbol,
    dataType,
    prospectusUrl,
    ctx,
  });

  openUrlInBrowser(prospectusUrl);

  return {
    kind: 'opened-url',
    url: prospectusUrl,
    message: 'IPO prospectus URL opened in browser',
  };
}